export const PHONE_DISPLAY = "+39 351 393 7976";
export const PHONE_TEL = "tel:+393513937976";
export const EMAIL = "formazione@anasmilano.com";

export const whatsappUrl = (modalita) => {
  let text =
    "Buongiorno, vorrei informazioni sul Corso SAB (ex REC) - Somministrazione Alimenti e Bevande.";
  if (modalita) {
    text += ` Sarei interessato/a alla modalità: ${modalita}.`;
  }
  return `https://wa.me/393513937976?text=${encodeURIComponent(text)}`;
};
